import { SVGProps } from 'react'

export const Ornament = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1.78260869565em"
      height="1em"
      viewBox="0 0 41 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M39.1602 5.11561C35.253 6.9723 31.6819 9.48562 28.4663 12.3903C25.7969 14.7872 23.4571 17.6564 21.6053 20.7454C21.3306 21.263 20.6972 22.4792 20.4225 23C20.5905 22.4242 20.9945 21.0883 21.1561 20.5417C21.4696 19.7556 21.7766 18.9114 22.103 18.1351C24.4913 12.8011 28.1237 8.07208 32.3735 4.05788C33.5789 2.93222 34.8199 1.84537 36.1482 0.855571C36.3098 0.72942 36.5231 0.583861 36.7137 0.454475C37.9257 -0.363892 39.5706 -0.0468949 40.3883 1.16286C41.3449 2.53759 40.7211 4.52043 39.1602 5.11237V5.11561Z"
        fill="#F16687"
      />
      <path
        d="M4.28537 0.561801C8.12147 3.37595 11.489 6.8435 14.3297 10.6377C16.5984 13.6524 18.4049 17.0068 19.6879 20.539C19.8624 21.1018 20.2502 22.428 20.4215 22.9973C20.15 22.4701 19.5037 21.2442 19.2387 20.7428C18.5277 19.5913 17.7262 18.3394 16.8827 17.2655C14.1842 13.7559 10.8491 10.7962 7.21981 8.31203C5.44881 7.13138 3.6164 5.99925 1.68381 5.11296C0.323244 4.57924 -0.348959 3.04601 0.181049 1.68099C0.795082 0.0377877 2.91834 -0.521808 4.28537 0.558566V0.561801Z"
        fill="#F16687"
      />
    </svg>
  )
}
